import { EMPTY_FUNCTION } from '../../../constants';
import { OverlayContextProps } from '../types';

export const default_overlay_context: OverlayContextProps = {
  theme: {},
  is_open: false,
  onClose: EMPTY_FUNCTION,
};
